import { useMemo, useEffect } from "react";
import { getTripKey } from "../../utils/tripAnalysis";
import { useEscaletedLinesTodayStore } from '../../stores/hashs/useEscaletedLinesTodayStore';
import { useTripAlertsAnalysisStore } from '../../stores/analysis/useTripAlertsAnalysisStore';
import { useAlertN1Store } from "../../stores/hashs/useAlertN1Store";


export function useAlertsN1() {

    const trips = useEscaletedLinesTodayStore(
        state => state.data
    );

    const totalDay = useEscaletedLinesTodayStore(
        state => state.total
    );

    const alertsMap = useTripAlertsAnalysisStore(
        state => state.alertsMap
    );

    const setAlertN1 =
        useAlertN1Store(
            state => state.setAlertN1
        );

    const value = useMemo(() => {

        const data = [];

        for (const trip of trips) {

            const alerts = alertsMap.get(
                getTripKey(trip.DATA_REFERENCIA, trip.CODIGO_INTEGRACAO)
            );

            if (!alerts?.n1) {
                continue;
            }

            data.push(trip);

        }

        const total = data.length;

        return {
            data,
            total,
            totalDay,
            percentTotal:
                totalDay
                    ? Math.round(total / totalDay * 100)
                    : 0
        };

    }, [
        trips,
        alertsMap,
        totalDay
    ]);


    useEffect(() => {

        setAlertN1(value);

    }, [
        value,
        setAlertN1
    ]);

}